import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { fetchMakers } from 'src/libs/api/makerApi';
import type { MakerSchema } from 'src/models/maker/schema';
import useSWR from 'swr';

const useMakers = (): {
  makers: MakerSchema[] | undefined;
  isLoading: boolean;
  isError: boolean;
} => {
  const { locale } = useRouter();
  const fetcher = useCallback(async (key: string[]): Promise<MakerSchema[]> => {
    return await fetchMakers(key[1]);
  }, []);
  const { data, isLoading, error } = useSWR(locale ? ['/api/makers', locale] : null, fetcher, {
    errorRetryCount: 0,
    dedupingInterval: 86400000 // 24時間,
  });

  return {
    makers: data,
    isLoading,
    isError: !!error
  };
};

export { useMakers };
